import { render, staticRenderFns } from "./promo-detail-v3.vue?vue&type=template&id=739410d6&scoped=true"
import script from "./promo-detail-v3.vue?vue&type=script&lang=js"
export * from "./promo-detail-v3.vue?vue&type=script&lang=js"
import style0 from "./promo-detail-v3.vue?vue&type=style&index=0&id=739410d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739410d6",
  null
  
)

export default component.exports